import React from "react"
import { Button } from "react-bootstrap"
import logoUAI from "../img/LogoUAI-black.png"
import "./SplashTour.css"

const SplashTour = (props) => {
  return (
    <div className="splash-ayuda">
      <h4>Tour de ayuda {props.titulo}</h4>
      <p>¡Hola! Queremos ayudarte con este tour guiado.</p>
      <p>
        Avanza haciendo clic en la flecha hacia la derecha o usando la flecha
        derecha del teclado.
      </p>
      <p>
        Puedes salir haciendo clic en la cruz arriba a la derecha o apretando la
        tecla Escape.
      </p>
      <p>
        Si necesitas más ayuda{" "}
        <a href="https://experiencia.uai.cl">escríbenos</a>.
      </p>
      <p>¡Comencemos! Haz clic en la flecha que apunta hacia la derecha.</p>
    </div>
  )
}

export default SplashTour
